import { createApp } from "vue";
import App from "@/App.vue";
import "@/assets/styles/tailwind.css";
import VueTailwindDatepicker from "vue-tailwind-datepicker";

//vuex
import store from "@/store";

//router
import router from "./router";

//vee-validate(https://vee-validate.logaretm.com/v4/guide/overview/)
import "./utils/veevalidate";
import { setLocale } from "@vee-validate/i18n";
import { Field, Form, ErrorMessage, FieldArray } from "vee-validate";
setLocale("ko");

//fontawesome(https://fontawesome.com/docs/web/use-with/vue/)
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import "@/utils/fontawesome";

//global Componet.vue
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Peroid from "@/components/Peroid.vue";
import Spac from "@/components/Spac.vue";
import ClassInfo from "@/components/ClassInfo.vue";
import Notice from "@/components/Notice.vue";
import Banner from "@/components/Banner.vue";
import Loading from "@/components/Loading.vue";
import Paging from "@/components/Paging.vue";
import SpacComplete from "@/components/SpacComplete.vue";
import ClassList from "@/components/global/ClassList.vue";
import LoadingBlur from "@/components/LoadingBlur";
import SaveLoading from "@/components/SaveLoading.vue";
import RoadCompletionComponent from "@/components/RoadCompletionComponent.vue";
//vue-flag-icon
import FlagIcon from "vue-flag-icon";

//vue-multiselect
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.css";

import Tracker from "@openreplay/tracker";
import { startSessionReplay } from "@/plugins/sessionReplay";

export const tracker = new Tracker({
  projectKey: "xUy4nmEFH3ZZKszhK5B9",
  ingestPoint: "https://replays.carrotsolutions.co.kr/ingest",
});

const isLocalhost =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

if (!isLocalhost) {
  tracker.start();
}

// 세션리플레이(자체 모니터링) 기동. localhost 는 SDK 가 자동 제외하므로 조건 없이 호출.
startSessionReplay();

const app = createApp(App).use(router);

//register Global Component
app.component("Header", Header);
app.component("Footer", Footer);
app.component("Peroid", Peroid);
app.component("Spac", Spac);
app.component("ClassInfo", ClassInfo);
app.component("Notice", Notice);
app.component("Banner", Banner);
app.component("Loading", Loading);
app.component("Paging", Paging);
app.component("SpacComplete", SpacComplete);
app.component("ClassList", ClassList);
app.component("LoadingBlur", LoadingBlur);
app.component("SaveLoading", SaveLoading);
app.component("RoadCompletion", RoadCompletionComponent);

//vue-multiselect
app.component("Multiselect", Multiselect);

//vee-validate Component
app.component("Field", Field);
app.component("Form", Form);
app.component("ErrorMessage", ErrorMessage);
app.component("FieldArray", FieldArray);

//font-awesome
app.component("FontAwesomeIcon", FontAwesomeIcon);

//vue-flag-icon
app.use(FlagIcon);

app.use(VueTailwindDatepicker);
app.use(store);
app.mount("#app");
